// @generated by protobuf-ts 2.11.1 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/event/activity/v2/click.proto" (package "bianka.event.activity.v2", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Organization } from "../../../core/enrichment/organization";
import { User } from "../../../core/enrichment/user";
import { Order } from "../../../core/enrichment/order";
import { Gig } from "../../../core/enrichment/gig";
import { Page } from "../../../common/activity/v1/page";
import { Element } from "../../../common/activity/v1/element";
import { ClickType } from "../../../enums/activity/click_type";
/**
 * Next serial number to be used: 11
 *
 * @generated from protobuf message bianka.event.activity.v2.Click
 */
export interface Click {
    /**
     * The type of the click
     *
     * @generated from protobuf field: string type = 1
     */
    type: string;
    /**
     * The click type of the event
     *
     * @generated from protobuf field: bianka.enums.activity.ClickType click_type = 2
     */
    clickType: ClickType;
    /**
     * Data regarding the clicked element
     *
     * @generated from protobuf field: bianka.common.activity.v1.Element element = 3
     */
    element?: Element;
    /**
     * Data regarding the page where the click happened
     *
     * @generated from protobuf field: bianka.common.activity.v1.Page page = 9
     */
    page?: Page;
    /**
     * Enrichments
     *
     * @generated from protobuf field: bianka.core.enrichment.Gig gig = 4
     */
    gig?: Gig;
    /**
     * @generated from protobuf field: bianka.core.enrichment.Order order = 5
     */
    order?: Order;
    /**
     * @generated from protobuf field: bianka.core.enrichment.User user = 6
     */
    user?: User;
    /**
     * @generated from protobuf field: bianka.core.enrichment.User buyer = 7
     */
    buyer?: User;
    /**
     * @generated from protobuf field: bianka.core.enrichment.User seller = 8
     */
    seller?: User;
    /**
     * @generated from protobuf field: bianka.core.enrichment.Organization organization = 10
     */
    organization?: Organization;
}
// @generated message type with reflection information, may provide speed optimized methods
class Click$Type extends MessageType<Click> {
    constructor() {
        super("bianka.event.activity.v2.Click", [
            { no: 1, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "bianka.core.extension.required": true } },
            { no: 2, name: "click_type", kind: "enum", T: () => ["bianka.enums.activity.ClickType", ClickType, "CLICK_TYPE_"] },
            { no: 3, name: "element", kind: "message", T: () => Element },
            { no: 9, name: "page", kind: "message", T: () => Page },
            { no: 4, name: "gig", kind: "message", T: () => Gig },
            { no: 5, name: "order", kind: "message", T: () => Order },
            { no: 6, name: "user", kind: "message", T: () => User },
            { no: 7, name: "buyer", kind: "message", T: () => User },
            { no: 8, name: "seller", kind: "message", T: () => User },
            { no: 10, name: "organization", kind: "message", T: () => Organization }
        ], { "bianka.core.extension.enrichment": { groupName: "event_ng" } });
    }
    create(value?: PartialMessage<Click>): Click {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = "";
        message.clickType = 0;
        if (value !== undefined)
            reflectionMergePartial<Click>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Click): Click {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string type */ 1:
                    message.type = reader.string();
                    break;
                case /* bianka.enums.activity.ClickType click_type */ 2:
                    message.clickType = reader.int32();
                    break;
                case /* bianka.common.activity.v1.Element element */ 3:
                    message.element = Element.internalBinaryRead(reader, reader.uint32(), options, message.element);
                    break;
                case /* bianka.common.activity.v1.Page page */ 9:
                    message.page = Page.internalBinaryRead(reader, reader.uint32(), options, message.page);
                    break;
                case /* bianka.core.enrichment.Gig gig */ 4:
                    message.gig = Gig.internalBinaryRead(reader, reader.uint32(), options, message.gig);
                    break;
                case /* bianka.core.enrichment.Order order */ 5:
                    message.order = Order.internalBinaryRead(reader, reader.uint32(), options, message.order);
                    break;
                case /* bianka.core.enrichment.User user */ 6:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* bianka.core.enrichment.User buyer */ 7:
                    message.buyer = User.internalBinaryRead(reader, reader.uint32(), options, message.buyer);
                    break;
                case /* bianka.core.enrichment.User seller */ 8:
                    message.seller = User.internalBinaryRead(reader, reader.uint32(), options, message.seller);
                    break;
                case /* bianka.core.enrichment.Organization organization */ 10:
                    message.organization = Organization.internalBinaryRead(reader, reader.uint32(), options, message.organization);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Click, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string type = 1; */
        if (message.type !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.type);
        /* bianka.enums.activity.ClickType click_type = 2; */
        if (message.clickType !== 0)
            writer.tag(2, WireType.Varint).int32(message.clickType);
        /* bianka.common.activity.v1.Element element = 3; */
        if (message.element)
            Element.internalBinaryWrite(message.element, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* bianka.core.enrichment.Gig gig = 4; */
        if (message.gig)
            Gig.internalBinaryWrite(message.gig, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* bianka.core.enrichment.Order order = 5; */
        if (message.order)
            Order.internalBinaryWrite(message.order, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* bianka.core.enrichment.User user = 6; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* bianka.core.enrichment.User buyer = 7; */
        if (message.buyer)
            User.internalBinaryWrite(message.buyer, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* bianka.core.enrichment.User seller = 8; */
        if (message.seller)
            User.internalBinaryWrite(message.seller, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* bianka.common.activity.v1.Page page = 9; */
        if (message.page)
            Page.internalBinaryWrite(message.page, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* bianka.core.enrichment.Organization organization = 10; */
        if (message.organization)
            Organization.internalBinaryWrite(message.organization, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.Click
 */
export const Click = new Click$Type();
